// extracted by mini-css-extract-plugin
export default {"overlay":"Preloader_overlay__9JR+6"};